import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as AppClasses from '../Application/styles.module.scss';
import * as Classes from './styles.module.scss';

export const CategoryPrints = () => (
  <h2>
    <span>A hand-picked collection of fine art prints</span>
    <span className={ Classes.divider }>/</span>
    <span>Unique framing options</span>
    <span className={ Classes.divider }>/</span>
    <span>Pre-designed gallery walls</span>
  </h2>
);

CategoryPrints.propTypes = {
  title: PropTypes.string
};

const CategoryHeader = ({ title, skipPrints }) => (
  <div className={ AppClasses.innerContainer20 }>
    <div className={ Classes.title }>
      <h1>{ title }</h1>
      { !skipPrints && <CategoryPrints /> }
    </div>
  </div>
);

CategoryHeader.propTypes = {
  title: PropTypes.string.isRequired,
  skipPrints: PropTypes.bool
};

export default CategoryHeader;
